import type { Field } from './types.tsx';

export const FIXED_IN: Field = {
	id: 'fixVersion',
	name: 'Fix Version',
};

export const AFFECTS: Field = {
	id: 'affectedVersion',
	name: 'Affects version',
};

const systemFields = [FIXED_IN, AFFECTS];

export default systemFields;
